import { AssementSessionData, Examiner, IExaminingTeamMemberWithFunctionId } from '../../models/taskGroup.types';
import { Examiner as ExaminerFromStructure, ExaminersList } from '../ExaminersStructure/ExaminersStructure.types';
import { Examiner as ExaminerFromSolution } from '../../services/examiners/examiners.types';
import { DashboardTile } from '../../pages/Dashboard/Dashboard.types';
import { SelectedExaminer } from '../../services/examiners/examiners.types';
import { SelectedUser } from '../../services/users/users.types';
import { Modal } from '../Modal/Modal.component';
import { NewMessage } from './NewMessage.component';
import { IndexedStrings } from '../SelectableTable/SelectableTable.types';
import { useState } from 'react';

interface NewMessageDialogProps {
  open: boolean;
  type: 'standard' | 'helpdesk' | 'specialCase' | 'orgzMessage';
  onClose: () => void;
  onSend: () => void;
  recipient?: Examiner | SelectedExaminer[] | SelectedUser[] | ExaminerFromStructure;
  session?: AssementSessionData | DashboardTile | null;
  shouldSessionDataBeHide?: boolean;
  isAllPagesItemChecked?: boolean;
  countOfAllCheckedRecipients?: number;
  recipientWithFunctionId?: ExaminersList;
  recipientWithFunctionIdFromExaminerTreemap?: IExaminingTeamMemberWithFunctionId;
  userFilters?: IndexedStrings;
  rgzId?: string;
  cardId?: string;
  recipientFromOrgz?: ExaminerFromSolution;
}

export const NewMessageModal: React.FC<NewMessageDialogProps> = (props) => {
  const [cancelConfirmationOpen, setCancelConfirmationOpen] = useState<boolean>(false);

  const getModalTitle = (type: string) => {
    switch (type) {
      case 'specialCase':
        return 'Szczególny Przypadek';
        break;
      case 'orgzMessage':
        return `RGZ: ${props.rgzId}`;
        break;
      default:
        return '';
    }
  };

  return (
    <Modal
      open={props.open}
      xCloseButton={() => setCancelConfirmationOpen(true)}
      title={`Nowa wiadomość ${getModalTitle(props.type)}`}
      autoHeight
      style={{ maxWidth: '750px', margin: '0 auto' }}
    >
      <div style={{ maxHeight: '700px' }}>
        <NewMessage
          onCancel={props.onClose}
          onSend={props.onSend}
          isModal
          recipient={props.recipient}
          session={props.session}
          shouldSessionDataBeHide={props.shouldSessionDataBeHide}
          isAllPagesItemChecked={props.isAllPagesItemChecked}
          countOfAllCheckedRecipients={props.countOfAllCheckedRecipients}
          messageType={props.type}
          recipientWithFunctionId={props.recipientWithFunctionId}
          recipientWithFunctionIdFromExaminerTreemap={props.recipientWithFunctionIdFromExaminerTreemap}
          userFilters={props.userFilters}
          setCancelConfirmationOpen={cancelConfirmationOpen}
          cancelConfirmationOpen={setCancelConfirmationOpen}
          rgzId={props.rgzId}
          cardId={props.cardId}
          recipientFromOrgz={props.recipientFromOrgz}
        />
      </div>
    </Modal>
  );
};
